<div class="app-container">
  <div class="app-toolbar">
    <div style="display: flex; align-items: center; gap: 12px">
      <p-button severity="secondary" [outlined]="true" (click)="drawerVisible = true;">
        <i class="pi pi-bars" pButtonIcon style="color: #000"></i>
      </p-button>

      <img ngSrc="exp-logo.svg" [width]="58" [height]="30" priority />
    </div>

    <div>
      <p-avatar
        (click)="toolbarUserMenu.toggle($event)"
        [image]="agentAvatar"
        [label]="agentAvatar ? undefined : agentInitials"
        class="user-avatar"
        size="normal"
        shape="circle"
      />
      <p-menu #toolbarUserMenu [model]="userMenuItems" [popup]="true" />
    </div>
  </div>

  <div class="app-main" style="display: flex; width: 100%; height: 100%">
    <div class="app-sidebar">
      <img ngSrc="exp-logo.svg" [width]="58" [height]="30" priority />

      <div class="nav-buttons">
        @for (item of navigationItems; track item) {
          <p-button
            severity="secondary"
            [outlined]="true"
            (click)="navigateTo(item.routerLink)"
            [pTooltip]="item.label"
            tooltipPosition="right"
          >
            <i [class]="item.icon" pButtonIcon style="color: #000"></i>
          </p-button>
        }
      </div>

      <div style="margin-top: auto">
        <p-avatar
          (click)="sidebarUserMenu.toggle($event)"
          [image]="agentAvatar"
          [label]="agentAvatar ? undefined : agentInitials"
          class="user-avatar"
          size="large"
          shape="circle"
        />
        <p-menu #sidebarUserMenu [model]="userMenuItems" [popup]="true" />
      </div>
    </div>

    <div class="app-content">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>

<p-drawer [(visible)]="drawerVisible" header="Navigate">
  <p-menu [model]="navigationItems" />
</p-drawer>
